<template>
  <div class="bulk-buying">
    <h2>まとめ買い</h2>
    <el-row type="flex">
      <el-col>
        <div class="input-cover">
          <div class="title">口数</div>
          <el-input-number v-model="quantity" :min="1" :max="maximumQuantity"></el-input-number>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="productData" type="flex" justify="center">
      <el-col :span="8">
        <table class="price-table">
          <tr>
            <th>単価</th>
            <td>{{ productData.priceWithTax | localeNum }}円</td>
          </tr>
          <tr>
            <th>口数</th>
            <td>{{ quantity }}</td>
          </tr>
          <tr>
            <th>計</th>
            <td>{{ productData.priceWithTax * quantity | localeNum }}円</td>
          </tr>
          <tr>
            <th>付与ポイント</th>
            <td>{{ productData.point * quantity | localeNum }}ポイント</td>
          </tr>
        </table>
        <p style="text-align: right;font-size: 12px;">※金額は全て税込み表示です。</p>
      </el-col>
    </el-row>
    <hr>
    <el-row>
      <el-col>
        <div class="button-cover">
          <el-button @click="buy()" type="primary" :disabled="productData === undefined">決済画面へ</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h3>まとめ買いについての特記事項</h3>
        <p>購入できる最大の口数は1ユーザーあたり{{ maximumQuantity }}口が上限となります。</p>
        <p>購入後のポイントの返却・返品はできませんことをご了承ください。</p>
        <p>通常、ポイントの有効期限は「購入後1年間」となっておりますが、まとめ買いいただいたポイントについては有効期限を「購入後3年間」とします。</p>
        <h3 style="color: red;margin-top: 2em;">※重要※ 決済エラーが発生したら</h3>
        <p>ご利用中のカード、および、まとめ買いの決済金額によっては、カード決済が保留になる場合がございます。</p>
        <p>カード決済エラーが発生した場合、当管理画面の右下に表示がある「お問い合わせ」からアドタスカルのサポートまでご連絡をお願いします。</p>
        <p>状況の確認のために、画面キャプチャをお送りください。</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
  },
  data() {
    return {
      //
      productId: '52',
      productList: [],

      //
      quantity: 1,
      maximumQuantity: 20
    }
  },
  computed: {
    ...mapGetters(['rt', 'apiErrorMessage', 'userData']),
    productData() {
      //
      const productData = this.productList.find(productData => productData.productId === this.productId);

      //
      return productData;
    },
  },
  created() {
    this.getProductList();
  },
  methods: {
    getProductList() {
      this.$axios
        .get(`${this.rt}/l/api/product/get-list`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            this.productList = response.data.list;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push(`/login`);
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    buy() {
      let params = new URLSearchParams();
      params.append("quantity", this.quantity);
      this.$axios
        .post(`${this.rt}/l/api/payment/buy-in-bulk`, params)
        .then((response) => {
          console.log(response);
          // CheckUserId ミドルウェアは旧方式（HTTP 200 + 本文 status:401）のままなのでここで拾う
          if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push(`/login`);
            return;
          }
          location.href = response.data.paymentUrl;
        })
        .catch((error) => {
          console.log(error);
          const responseData = error.response ? error.response.data : null;
          if (responseData && responseData.message) {
            alert(responseData.message);
          } else {
            alert(this.apiErrorMessage);
          }
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.input-cover {
  margin-top: 2em;
  display: flex;
  justify-content: center;
  align-items: center;

  .title {
    margin-right: 1em;
  }
}

.price-table {
  margin-top: 2em;
  width: 100%;

  td {
    text-align: right;
  }
}

.button-cover {
  margin-top: 1em;
  text-align: center;
}
</style>
